import { useEffect, useState, useContext, useMemo, useCallback } from "react";
import PageHeader from "../pageheader/PageHeader";
import moment from "moment/moment";
import * as patientApi from "../../service/patientApiDev";
import { useNavigate, useSearchParams } from "react-router-dom";
import { RedirectCode400 } from "../RedirectCode400";
// import { environment } from "../../config.env";
import { CurrentUserContext } from "../../App";
import TabView from "../material/tabView/tabView";
import DataTable from "react-data-table-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock } from "@fortawesome/free-solid-svg-icons";
import Button from "../material/button/Button";
import Breadcrumb from "../public/breacrumb/breadcrumb";
import { HashLoader } from "react-spinners";

// const ENDPOINT_DOMAIN = environment.endpoint_domain || "";

const customStyles = {
  table: {
    style: {
      minWidth: "700px",
    },
  },
  rows: {
    style: {
      minHeight: "56px",
      "&:nth-child(even)": {
        backgroundColor: "#f9fafb",
      },
    },
  },
  headRow: {
    style: {
      backgroundColor: "#f3f4f6",
      borderBottomWidth: "2px",
      borderBottomColor: "#e5e7eb",
    },
  },
  headCells: {
    style: {
      fontSize: 14,
      fontWeight: 700,
      color: "#111827",
      paddingTop: "14px",
      paddingBottom: "14px",
      paddingLeft: "16px",
      paddingRight: "16px",
    },
  },
  cells: {
    style: {
      fontSize: 14,
      color: "#1f2937",
      lineHeight: "1.6",
      paddingTop: "12px",
      paddingBottom: "12px",
      paddingLeft: "16px",
      paddingRight: "16px",
    },
  },
};

let day = new Date().toLocaleDateString("th-TH", {
  year: "numeric",
  month: "long",
  day: "numeric",
});

const NAT2StatusGauge = ({ resultName }) => {
  const getLevel = (name) => {
    if (name?.includes("RAPID")) return 1;
    if (name?.includes("INTERMEDIATE")) return 2;
    if (name?.includes("SLOW")) return 3;
    return 0;
  };
  const level = getLevel(resultName);
  if (level === 0) return null;

  return (
    <div className="flex flex-col gap-1 ml-auto pl-6">
      <span className="text-[13px] text-[#9e9e9e] font-bold uppercase tracking-wider">
        NAT2 Status
      </span>
      <div className="flex items-center gap-2">
        <div className="flex h-5 w-32 bg-gray-100 rounded-full overflow-hidden border border-gray-200">
          <div
            className={`w-1/3 ${level === 1 ? "bg-red-500" : "bg-red-200 opacity-30"}`}
          />
          <div
            className={`w-1/3 border-x border-white ${level === 2 ? "bg-green-900" : "bg-green-200 opacity-30"}`}
          />
          <div
            className={`w-1/3 ${level === 3 ? "bg-[#e0462b]" : "bg-red-200 opacity-30"}`}
          />
        </div>
        <span
          className={`text-md font-bold ${level === 2 ? "text-green-900" : "text-red-500"}`}
        >
          {level === 1
            ? "RAPID ACETYLATOR"
            : level === 2
              ? "INTERMEDIATE ACETYLATOR"
              : "SLOW ACETYLATOR"}
        </span>
      </div>
    </div>
  );
};

function LaboratoryResult() {
  const { setIsMessage } = useContext(CurrentUserContext);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const appToken = searchParams.get("token");
  const isViewerMode = Boolean(appToken);

  const [loading, setLoading] = useState(false);
  const [viewerToken, setViewerToken] = useState(null);
  const user = JSON.parse(localStorage.getItem("user"));
  const [LabList, setLabList] = useState([]);
  const [LabListfilter, setLabListFilter] = useState("");
  const [LabSelect, setLabSelect] = useState("");
  const [optionList, setOptionList] = useState([]);
  const [optionFilter, setoptionFilter] = useState("");

  const latestNAT2 = useMemo(() => {
    return LabList.find((item) => item.expr2?.toLowerCase().includes("nat2"))
      ?.lab_classify?.lab_result?.result?.result_name;
  }, [LabList]);

  useEffect(() => {
    setLabSelect("");
  }, [optionFilter]);

  const onChangeSelect = (e) => {
    setoptionFilter(e);

    const searchTerm = e.toLowerCase();
    const filtered = LabList.filter((item) => {
      const expr2Match = item?.expr2?.toLowerCase().includes(searchTerm);

      const labNameMatch = item?.lab_classify?.lab_result?.lab_name
        ?.toLowerCase()
        .includes(searchTerm);

      const labTypeNameMatch = item?.lab_classify?.lab_type_name
        ?.toLowerCase()
        .includes(searchTerm);

      return expr2Match || labNameMatch || labTypeNameMatch;
    });
    setLabListFilter(filtered);
  };

  const getLabInformation = useCallback(async (resolvedViewerToken) => {
    setLoading(true);
    try {
      let res = isViewerMode
        ? await patientApi.getLabInformationByViewerToken(resolvedViewerToken)
        : await patientApi.getLabInformation();

      if (res) {
        if (res["data"]["code"] === 200) {
          let labList = res["data"]["lab_list"];
          const unique = [...new Map(labList.map(item => [item.expr2, item])).values()];
          setLabList(unique);
          setLabListFilter(unique);
        } else if (res["data"]["code"] === 401) {
          navigate("/404");
        } else if (res["data"]["code"] === 403) {
          if (!isViewerMode) navigate(RedirectCode400());
          else navigate("/404");
        } else if (res["data"]["code"] === 404) {
          navigate("/404");
        } else {
          setIsMessage({
            type: "warning",
            data: res["data"]["message_th"] || res["data"]["message"],
          });
        }
      } else {
        setIsMessage({
          type: "error",
          data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
        });
      }
    } catch (error) {
      console.error("Fetch error:", error);
    } finally {
      setLoading(false);
    }
  }, [navigate, setIsMessage, isViewerMode]);

  useEffect(() => {
    setOptionList([
      { key: "", value: "ผลการตรวจทั้งหมด" },
      { key: "HLA-B*58:01", value: "HLA-B*58:01" },
      { key: "HLA-B*57:01", value: "HLA-B*57:01" },
      { key: "HLA-B*15:02", value: "HLA-B*15:02" },
      { key: "NAT2-diplotype", value: "NAT2-diplotype" },
      { key: "HLA-A*31:01", value: "HLA-A*31:01" },
      { key: "HLA-B*13:01", value: "HLA-B*13:01" },
    ]);

    if (isViewerMode) {
      // Viewer mode: authenticate ด้วย token จาก App ก่อน แล้วค่อยดึงแลป
      patientApi.authenticateViewerToken(appToken).then((authRes) => {
        if (authRes && authRes["data"]["code"] === 200) {
          const token = authRes["data"]["viewer_token"];
          setViewerToken(token);
          getLabInformation(token);
        } else {
          navigate("/404");
        }
      });
    } else {
      getLabInformation();
    }
  }, [isViewerMode, appToken, navigate, getLabInformation]);

  const columnsListResult = [
    {
      name: "ลำดับ",
      selector: (item, index) => (
        <div className="text-center w-[30px]">{index + 1}</div>
      ),
      wrap: true,
      width: "80px",
    },
    {
      name: "รายการ",
      selector: (item) => <div className="text-base">{item["expr2"]}</div>,
      wrap: true,
      grow: 2,
      minWidth: "220px",
    },
    {
      name: "ผลการตรวจยีน",
      selector: (item) => (
        <div>
          {item?.lab_classify?.lab_result?.result?.result_name?.includes(
            "POSITIVE",
          ) ||
          item?.lab_classify?.lab_result?.result?.result_name?.includes(
            "SLOW",
          ) ||
          item?.lab_classify?.lab_result?.result?.result_name?.includes(
            "RAPID",
          ) ? (
            <div className="px-4 py-1 text-xs text-white bg-red-500 rounded-full">
              {item["lab_classify"]["lab_result"]["result"]["result_name"]}
            </div>
          ) : (
            <div className="px-4 py-1 text-xs text-white bg-green-900  rounded-full">
              {item["lab_classify"]["lab_result"]["result"]["result_name"]}
            </div>
          )}
        </div>
      ),
      wrap: false,
      width: "250px",
    },
    {
      name: "สรุปผลการตรวจเมื่อ",
      selector: (item) => (
        <div className="text-[#9e9e9e]">
          {moment(item["report_date"]).add(543, "years").format("DD MMMM YYYY")}
        </div>
      ),
      wrap: true,
      width: "220px",
    },
    {
      name: "",
      selector: (item) => (
        <div>
          <div
            className={`w-20 p-[5px] text-center border border-[#42A1EF] rounded-md ${item["_id"] === LabSelect ? "bg-[#42A1EF] text-white" : "bg-white text-[#42A1EF] cursor-pointer"}`}
            onClick={() => setLabSelect(item["_id"])}
          >
            ดูผลแลป
          </div>
        </div>
      ),
      wrap: true,
      width: "120px",
    },
  ];

  const pathItems = [
    { name: "หน้าหลัก", url: "/" },
    { name: "ผลการตรวจทางเภสัชพันธุศาสตร์", url: "/" },
  ];

  return (
    <>
      <div className="global-page">
        <Breadcrumb pathItems={pathItems} />

        <PageHeader titlename={"ผลการตรวจทางเภสัชพันธุศาสตร์"} />
        {/* Patient Infomation */}
        {!isViewerMode && (
          <div className="2lg:flex-col 2lg:items-center flex flex-row gap-5 w-full p-4 mb-4 bg-white rounded-md shadow-md">
            <div className="overflow-hidden aspect-square w-[15%]">
              <img
                className="h-full object-cover"
                src={`${
                  user?.profile_image && user.profile_image.length > 0
                    ? user.profile_image
                    : require("../../asset/image/image-user.svg").default
                }`}
                alt="imguser"
              />
            </div>
            <div className="2lg:items-center flex flex-col gap-5 justify-center w-full">
              <div className="lg:items-center flex flex-col gap-1">
                <p className="text-base text-[#4F9C9D]">ข้อมูลผลการตรวจยีน</p>
                <p className="text-lg font-bold text-[#4F9C9D]">
                  {user?.pname || user?.profile?.pname} {user?.fname || user?.profile?.fname} {user?.lname || user?.profile?.lname}
                </p>
              </div>
              <div className="lg:flex-col flex flex-row gap-8">
                <div className="lg:items-center lg:flex-row lg:gap-5 flex flex-col gap-1">
                  <p className="text-base text-gray-500">เลขบัตรประชาชน</p>
                  <p className="sm:text-base text-lg font-bold">{user?.pid}</p>
                </div>
                <div className="lg:items-center lg:flex-row lg:gap-5 flex flex-col gap-1">
                  <p className="text-base text-gray-500">วันเกิด</p>
                  <p className="sm:text-base text-lg font-bold">
                    {moment(user?.profile?.birthday || user?.birthday, ["DD/MM/YYYY", "YYYY-MM-DD"])
                      .add(543, "years")
                      .format("DD MMMM YYYY")}
                  </p>
                </div>
                <div className="lg:items-center lg:flex-row lg:gap-5 flex flex-col gap-1">
                  <p className="text-base text-gray-500">อายุ</p>
                  <p className="sm:text-base text-lg font-bold">
                    {moment().diff(
                      moment(user?.profile?.birthday || user?.birthday, ["DD/MM/YYYY", "YYYY-MM-DD"]),
                      "years"
                    )}
                    ปี
                  </p>
                </div>
                <div className="lg:items-center lg:flex-row lg:gap-5 flex flex-col gap-1">
                  <p className="text-base text-gray-500">เบอร์โทร</p>
                  <p className="sm:text-base text-lg font-bold">
                    {user?.phone_number || user?.profile?.phone_number}
                  </p>
                </div>
                <div className="lg:items-center lg:flex-row lg:gap-5 flex flex-col gap-1">
                  <p className="text-base text-gray-500">อีเมล</p>
                  <p className="sm:text-base text-lg font-bold">{user?.email || user?.profile?.email}</p>
                </div>
              </div>
            </div>
          </div>
        )}

        <TabView
          value={optionFilter}
          list={optionList}
          select={onChangeSelect}
        />

        <div className="flex flex-wrap justify-between items-center mt-[12px]">
          <div className="text-2xl font-bold">{optionFilter}</div>

          {optionFilter === "NAT2-diplotype" && (
            <div style={{ margin: "20px 0" }}>
              <NAT2StatusGauge resultName={latestNAT2} />
            </div>
          )}
        </div>

        {loading ? (
          <div className="flex justify-center items-center mt-[10px]">
            <HashLoader color="#FF9768" size={70} />
            <div
              style={{
                marginTop: "20px",
                color: "#FF9768",
                fontWeight: "600",
                fontSize: "18px",
              }}
            >
              loading...
            </div>
          </div>
        ) : (
          <div>
            <div className="flex flex-wrap gap-1 p-3 bg-white w-full">
              <div className="text-sm text-gray-600 w-full">
                <FontAwesomeIcon icon={faClock} className="mr-1" /> ข้อมูลประจำวันที่ {day}
              </div>
              {optionFilter === "" && (
                <div className="text-sm font-semibold text-gray-700 w-full">
                  จำนวน {LabList.length} รายการ
                </div>
              )}
            </div>
            <div className="overflow-x-auto w-full">
              <DataTable
                className="border-t-[2px] border-gray-200"
                columns={columnsListResult}
                data={LabListfilter}
                customStyles={customStyles}
                pagination
                noDataComponent={<div style={{ margin: "10%" }}>ไม่พบข้อมูล</div>}
              />
            </div>
          </div>
        )}

        {LabSelect !== "" && (
          <>
            {LabList.filter((item) => {
              return item["_id"]?.includes(LabSelect);
            }).map((item, idx) => {
              return (
                <>
                  <div className="flex flex-col gap-[2px] w-full bg-gray-200 p-[2px] mt-10 rounded-lg">
                    <div className="flex flex-row gap-[2px] w-full bg-white rounded-t-lg">
                      <div className="w-[20%] p-5 border-r-[2px] border-gray-200 font-bold">
                        ชื่อการตรวจ
                      </div>
                      <div className="w-full p-5 text-2xl font-bold">
                        {item["expr2"]}
                      </div>
                    </div>
                    <div className="flex flex-row gap-[2px] w-full bg-white">
                      <div className="w-[20%] p-5 border-r-[2px] border-gray-200 font-bold">
                        ผลการตรวจ
                      </div>
                      <div className="w-full p-5 text-base">
                        {item["expr2"]}
                      </div>
                    </div>
                    <div className="flex flex-row gap-[2px] w-full bg-white">
                      <div className="w-[20%] p-5 border-r-[2px] border-gray-200 font-bold">
                        วัตถุประสงค์
                      </div>
                      <div className="w-full p-5 text-base">
                        {item["lab_classify"]["lab_result"]["objective"]}
                      </div>
                    </div>
                    <div className="flex flex-row gap-[2px] w-full bg-white">
                      <div className="w-[20%] p-5 border-r-[2px] border-gray-200 font-bold">
                        หน่วยงานที่ส่งตรวจ
                      </div>
                      <div className="w-full p-5 text-base">
                        {item["customer_name"]}
                      </div>
                    </div>
                    <div className="flex flex-row gap-[2px] w-full bg-white">
                      <div className="w-[20%] p-5 border-r-[2px] border-gray-200 font-bold">
                        วันที่เก็บตัวอย่าง
                      </div>
                      <div className="w-full p-5 text-base">
                        {moment(item["collect_date"])
                          .add(543, "years")
                          .format("DD MMMM YYYY")}
                      </div>
                    </div>
                    <div className="flex flex-row gap-[2px] w-full bg-white">
                      <div className="w-[20%] p-5 border-r-[2px] border-gray-200 font-bold">
                        วันที่ตรวจ
                      </div>
                      <div className="w-full p-5 text-base">
                        {moment(item["report_date"])
                          .add(543, "years")
                          .format("DD MMMM YYYY")}
                      </div>
                    </div>
                    <div className="flex flex-row gap-[2px] w-full bg-white">
                      <div className="w-[20%] p-5 border-r-[2px] border-gray-200 font-bold">
                        ผลการวิเคราะห์
                      </div>
                      <div className="w-full p-5 text-base">
                        {item["testing_result"]}
                      </div>
                    </div>
                    <div className="flex flex-row gap-[2px] w-full bg-white rounded-b-lg">
                      <div className="w-[20%] p-5 border-r-[2px] border-gray-200 font-bold">
                        ข้อมูลจากระบบ
                      </div>
                      <div className="w-full p-5 text-base">-</div>
                    </div>
                  </div>

                  <div className="flex flex-col w-full bg-[#6cc9ca] p-5 mt-2 rounded-lg">
                    {item["lab_classify"]["lab_result"]["result"][
                      "recommend_patient"
                    ].map((recommend, idx) => (
                      <div key={idx}>{recommend}</div>
                    ))}
                  </div>
                  {item["lab_classify"]["lab_result"]["lab_key"] ===
                  "hla-b*58:01" ? (
                    <div className="flex flex-col w-full bg-[#ffe07a] p-5 mt-2 rounded-lg">
                      <div>
                        จากการศึกษาที่ผ่านมาพบว่า คนไทยที่เป็น SJS/TEN จากการใช้
                        allopurinol ทั้ง 27 คน มี HLA-B*58:01 ทุกคนถึงแม้จะพบว่า
                        มีร้อยละ 13 (7/54) ของคนไทยไม่ได้เป็น SJS/TEN จากการใช้
                        allopurinol ทั้งที่มี HLA-B*58:01 (Tassaneeyakul et.
                        al., 2009)
                      </div>
                    </div>
                  ) : item["lab_classify"]["lab_result"]["lab_key"] ===
                    "hla-b*57:01" ? (
                    <div className="flex flex-col w-full bg-[#ffe07a] p-5 mt-2 rounded-lg">
                      <div>
                        จากการศึกษาที่ผ่านมาพบว่า คนไทยที่เป็น SJS/TEN จากการใช้
                        allopurinol ทั้ง 27 คน มี HLA-B*58:01 ทุกคนถึงแม้จะพบว่า
                        มีร้อยละ 13 (7/54) ของคนไทยไม่ได้เป็น SJS/TEN จากการใช้
                        allopurinol ทั้งที่มี HLA-B*58:01 (Tassaneeyakul et.
                        al., 2009)
                      </div>
                    </div>
                  ) : item["lab_classify"]["lab_result"]["lab_key"] ===
                    "hla-b*58:01" ? (
                    <div className="flex flex-col w-full bg-[#ffe07a] p-5 mt-2 rounded-lg">
                      <div>
                        จากการศึกษาที่ผ่านมาพบว่า คนไทยที่เป็น SJS/TEN จากการใช้
                        allopurinol ทั้ง 27 คน มี HLA-B*58:01 ทุกคนถึงแม้จะพบว่า
                        มีร้อยละ 13 (7/54) ของคนไทยไม่ได้เป็น SJS/TEN จากการใช้
                        allopurinol ทั้งที่มี HLA-B*58:01 (Tassaneeyakul et.
                        al., 2009)
                      </div>
                    </div>
                  ) : item["lab_classify"]["lab_result"]["lab_key"] ===
                    "nat2_diplotype" ? (
                    <div className="flex flex-col w-full bg-[#ffe07a] p-5 mt-2 rounded-lg">
                      <div>
                        จากการศึกษาที่ผ่านมาพบว่า คนไทยที่เป็น SJS/TEN จากการใช้
                        allopurinol ทั้ง 27 คน มี HLA-B*58:01 ทุกคนถึงแม้จะพบว่า
                        มีร้อยละ 13 (7/54) ของคนไทยไม่ได้เป็น SJS/TEN จากการใช้
                        allopurinol ทั้งที่มี HLA-B*58:01 (Tassaneeyakul et.
                        al., 2009)
                      </div>
                    </div>
                  ) : null}
                  <div className="flex justify-end w-full py-5 mt-2">
                    <Button
                      style={{ width: "40%" }}
                      onClick={() => navigate("/questionnaire")}
                    >
                      ประเมินความพึงพอใจ
                    </Button>
                  </div>
                </>
              );
            })}
          </>
        )}
      </div>
    </>
  );
}

export default LaboratoryResult;
